module.exports = __webpack_public_path__ + "static/ishizaka-1b6a7354dba5a827964608b2589b36ef.png";